export enum ArchiveEmployeeCopy {
  TITLE = 'Are you sure you want to archive this employee?',
  SUBTITLE = 'You will no longer be able to send equipment or retrieve assets from this employee once archived. All historical order and asset data will remain within the system.',
  SUBMIT_BUTTON_COPY = 'Yes, archive',
  CANCEL_BUTTON_COPY = 'No, cancel',
}
